/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../../app/components/reports/filterSelectors/agentSelector/agentSelector.component';
import * as i2 from '../../../../../../app/services/configService';
const styles_AgentSelectorComponent:any[] = ([] as any[]);
export const RenderType_AgentSelectorComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AgentSelectorComponent,data:{}});
export function View_AgentSelectorComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,[['agentSelect',1]],(null as any),1,'select',
      [['class','form-control select2'],['name','agentSelect'],['required','']],[[1,
          'id',0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),[' ']))],(null as any),(_ck,_v) => {
    var _co:i1.AgentSelectorComponent = _v.component;
    const currVal_0:any = _co.select2Id;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_AgentSelectorComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'agent-selector',
      ([] as any[]),(null as any),(null as any),(null as any),View_AgentSelectorComponent_0,
      RenderType_AgentSelectorComponent)),i0.ɵdid(4243456,(null as any),0,i1.AgentSelectorComponent,
      [i2.ConfigService],(null as any),(null as any))],(null as any),(null as any));
}
export const AgentSelectorComponentNgFactory:i0.ComponentFactory<i1.AgentSelectorComponent> = i0.ɵccf('agent-selector',
    i1.AgentSelectorComponent,View_AgentSelectorComponent_Host_0,{currentAgent:'currentAgent',
        select2Id:'select2Id',agentColors:'agentColors',allAgents:'allAgents'},{agentsChange:'agentsChange'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9maWx0ZXJTZWxlY3RvcnMvYWdlbnRTZWxlY3Rvci9hZ2VudFNlbGVjdG9yLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9yZXBvcnRzL2ZpbHRlclNlbGVjdG9ycy9hZ2VudFNlbGVjdG9yL2FnZW50U2VsZWN0b3IuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9maWx0ZXJTZWxlY3RvcnMvYWdlbnRTZWxlY3Rvci9hZ2VudFNlbGVjdG9yLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9maWx0ZXJTZWxlY3RvcnMvYWdlbnRTZWxlY3Rvci9hZ2VudFNlbGVjdG9yLmNvbXBvbmVudC50cy5BZ2VudFNlbGVjdG9yQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNlbGVjdCAjYWdlbnRTZWxlY3QgW2F0dHIuaWRdPVwic2VsZWN0MklkXCIgY2xhc3M9XCJmb3JtLWNvbnRyb2wgc2VsZWN0MlwiIHJlcXVpcmVkIG5hbWU9XCJhZ2VudFNlbGVjdFwiPiA8L3NlbGVjdD4iLCI8YWdlbnQtc2VsZWN0b3I+PC9hZ2VudC1zZWxlY3Rvcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtVQUFBLG1FQUFvRzthQUFBOztJQUEvRTtJQUFyQixXQUFxQixTQUFyQjs7OztvQkNBQTtNQUFBO3VDQUFBLFVBQUE7TUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./compiled/app/components/reports/filterSelectors/agentSelector/agentSelector.component.ngfactory.ts